import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  margin-left: -23px;
`;

export const ContainerSidebar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  position: relative;
  gap: 8px;
`;

interface IIcon {
  width: number;
}

export const Block = styled.div<IIcon>`
  background: #fff;
  border-radius: 8px;
  position: absolute;
  top: 22px;
  right: 85px;
  width: 190px;
  z-index: 10;
  cursor: auto;
`;

export const CircleDiv = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  color: ${beam.color.pureWhite};
  background: ${beam.color.primaryBlue};

  border-radius: 50%;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  font-size: 10px;
  font-weight: 700;
  right: -5px;
  bottom: -5px;
  width: 14px;
  height: 14px;
`;

export const Icon = styled.div<IIcon>`
  min-width: ${({ width }) => width}px;
  width: ${({ width }) => width}px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MenuIcon = styled.img`
  margin-left: 24px;
  cursor: pointer;
`;

export const MenuText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1371fe;
`;

export const IconContainer = styled.div`
  padding-top: 5px;
`;
